import { initGraphQLTada } from "gql.tada";
import type { JsonValue } from "./graphql/json-value";
import type { introspection } from "./graphql/schema";

/**
 * パッケージ内で完結する gql.tada の graphql タグ。
 * グローバルな `declare module "gql.tada"` に依存しないため、frontend-v2 / mcp
 * どちらのコンパイル環境に取り込まれても augmentation の衝突が起きない。
 * scalars は frontend-v2 / mcp の schema.custom-scalars.d.ts と揃えること。
 */
export const graphql = initGraphQLTada<{
  introspection: introspection;
  scalars: {
    Date: string;
    Time: string;
    Upload: File;
    JSON: JsonValue;
  };
}>();
